<template>
    <div id="app">
        <div class="container-fluid">
            <Payment/>
        </div>
    </div>
</template>

<script>
    import Payment from './components/payment/Payment'

    export default {
        name: 'app',
        components: {
            Payment
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
